var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilot = function SvgTrustpilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 799.89 761"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b67a",
    d: "M799.89 290.83H494.44L400.09 0l-94.64 290.83L0 290.54l247.37 179.92L152.72 761l247.37-179.63L647.16 761l-94.35-290.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005128",
    d: "m574.04 536.24-21.23-65.78-152.72 110.91z"
  })));
};
export default SvgTrustpilot;